import CustomMenu from './CustomMenu';
import { isMobile } from 'react-device-detect';
import InstallationPromo from '../InstallationPromo';
import { useLocation } from 'react-router-dom';
import { lazy, Suspense } from 'react';
const AnchorTopAds = lazy(() => import("../../Components/Ads"));
function Header({ isEnglish }) {
  const location = useLocation();
  ;
  // Check if current page is the tally counter
  const hideAnchorAds =
    location.pathname.toLowerCase().includes('tally') ||
    location.pathname.toLowerCase().includes('zakat') ||
    location.pathname.toLowerCase().includes('athkar');
  return (
    <div>
      {/* Fixed ad at top on mobile (not on tally counter page) */}
      {isMobile && !hideAnchorAds && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1050,
          backgroundColor: '#fff'
        }}>
          <Suspense fallback={<div style={{ height: '100px' }}></div>}>
            <AnchorTopAds />
          </Suspense>
        </div>
      )}
      {/* Spacer for fixed ad */}
      {isMobile && !hideAnchorAds && (
        <div style={{ height: '100px' }}></div>
      )}
      {/* Scrollable navbar */}
      <div>
        <CustomMenu />
      </div>
      {isMobile && <InstallationPromo />}
      <br />
    </div>
  );
}
export default Header;